/**
 * Generate a human-readable name for an agent based on its strategy text.
 * Uses keyword pattern matching with a fallback to the first few words.
 */
export function generateAgentName(strategy: string): string {
  const patterns: [RegExp, string][] = [
    [/momentum\s+trad/i, 'Momentum Trader'],
    [/swing\s+trad/i, 'Swing Trader'],
    [/day\s+trad/i, 'Day Trader'],
    [/scalp/i, 'Scalper'],
    [/accumul/i, 'Accumulator'],
    [/dca|dollar.cost/i, 'DCA Bot'],
    [/diversif/i, 'Diversified Portfolio'],
    [/conserv/i, 'Conservative Trader'],
    [/aggress/i, 'Aggressive Trader'],
    [/snip/i, 'Sniper Bot'],
    [/arbitr/i, 'Arbitrage Bot'],
    [/mean.revers/i, 'Mean Reversion'],
    [/trend.follow/i, 'Trend Follower'],
    [/breakout/i, 'Breakout Trader'],
  ];

  for (const [pattern, name] of patterns) {
    if (pattern.test(strategy)) return name;
  }

  // Fallback: first 4-5 meaningful words
  const words = strategy
    .replace(/^you are an?\s+/i, '')
    .replace(/^the agent (should|will|must)\s+/i, '')
    .split(/\s+/)
    .slice(0, 5)
    .join(' ');

  return words.length > 40 ? `${words.slice(0, 40)}...` : words;
}
